import { useTranslation } from 'react-i18next'
import { HugeiconsIcon } from '@hugeicons/react'
import { ArrowDown01Icon, Delete02Icon, DragDropIcon, SquareIcon } from '@hugeicons-pro/core-stroke-rounded'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Box } from '@mui/system'
import PropTypes from 'prop-types'

import OrderItemStatus from '../common/OrderItemStatus'

const classes = {
    Overlay: {
        borderRadius: 2,
        overflow: 'hidden',
        backgroundColor: 'action.hover',
    },

    OverlayContent: {
        px: 2,
        py: 1.5,
        display: 'flex',
        justifyContent: 'space-between',
        height: 74,
    },

    OverlayContentLeft: {
        gap: 1.5,
    },

    OverlayContentRight: {
        gap: 6,
    },

    OverlayContentColor: {
        color: 'text.secondary',
    },

    OverlayDetailsContent: {
        height: 436,
        backgroundColor: 'background.default',
    },
}

const SeekOrderItemOverlay = ({ height, index }) => {
    const { t } = useTranslation()

    return (
        <Box
            id={index}
            index={index}
            sx={classes.Overlay}
        >
            <Box sx={classes.OverlayContent}>
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentLeft,
                    ]}
                >
                    <Typography variant="body1">{index + 1}</Typography>
                    <IconButton
                        size="small"
                        sx={classes.OverlayContentColor}
                    >
                        <HugeiconsIcon
                            icon={DragDropIcon}
                            size={20}
                        />
                    </IconButton>

                    <HugeiconsIcon
                        icon={SquareIcon}
                        size={18}
                        sx={classes.OverlayContentColor}
                    />

                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 2,
                        }}
                    >
                        <OrderItemStatus status="overlay" />

                        <Typography sx={classes.OverlayContentColor}>{t('loading part...')}</Typography>
                    </Box>
                </Box>

                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                        },
                        classes.OverlayContentRight,
                    ]}
                >
                    <Box
                        sx={{
                            alignItems: 'center',
                            display: 'flex',
                        }}
                    >
                        <IconButton sx={classes.OverlayContentColor}>
                            <HugeiconsIcon
                                icon={Delete02Icon}
                                size={20}
                            />
                        </IconButton>

                        <HugeiconsIcon
                            icon={ArrowDown01Icon}
                            size={20}
                            sx={classes.OverlayContentColor}
                        />
                    </Box>
                </Box>
            </Box>
            {height > 400 ? <Box sx={classes.OverlayDetailsContent}></Box> : null}
        </Box>
    )
}

SeekOrderItemOverlay.propTypes = {
    height: PropTypes.number.isRequired,
    index: PropTypes.number.isRequired,
}

export default SeekOrderItemOverlay
